import React from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import { TableCell } from "../../UI/TableCell";
import { TableRow } from "../../UI/TableRow";
import { MatchingRoundCircle } from "../../components/MatchingRoundStatus";
import { Box } from "../../UI/Box";

import { dateToMMDDYY, getDate } from "../../common/date_utils";
import { ModalProvider } from "../../contexts/ModalContext";
import { UserNameLink } from "../UserNameLink";
import { HelpTooltip } from "../HelpTooltip";

interface IProps {
  isImportDate?: boolean;
  isGlobalSearch: boolean;
  user: Record<string, any>;
}


const MatchingRoundWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    .MuiAvatar-root {
      margin-right: 5px;
    }
`;

const UnitTypeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const PauseIcon = styled.img`
    width: 16px;
    height: 16px;
`;

const HELP_TOOLTIP_TEXT = "Matching for this unit type has been paused";

export const UserSearchResultsTableBodyRow: React.FC<IProps> = (props) => {
  let l1Name = props.user.l1IdName || "User not in community";
  let l2Name = props.user.l2IdName || "N/A";
  let l3Name = props.user.l3IdName || "N/A";
  let l4Name = props.user.l4IdName || "N/A";
  const status = props.user.matchingRoundStatus || "N/A";
  const isPaused = props.user.forcedClosed === true;
  // console.log('UserSearchResultsTableBodyRow props:', props, isPaused, status);
  const isMatchingStatus = status === "MATCHING";
  const showPauseIcon = isPaused && isMatchingStatus;


  return (
    <TableRow>
      <TableCell>
        <ModalProvider>
          <UserNameLink name={props.user.name} id={props.user.id} openNewTab />
        </ModalProvider>
      </TableCell>
      <TableCell>
        <MatchingRoundWrapper>
          <MatchingRoundCircle status={status} />
          {l2Name}
        </MatchingRoundWrapper>
        </TableCell>
      <TableCell>{props.user.email}</TableCell>
      {props.isGlobalSearch && <TableCell>{l1Name}</TableCell>}

      <TableCell>
        <UnitTypeWrapper>
          {l3Name}
          {showPauseIcon && (
            <Tooltip title="Matching for this unit type has been paused">
              <Box component="span" display="inline-flex" alignItems="center">
                <HelpTooltip text={HELP_TOOLTIP_TEXT} withIcon={false}>
                <PauseIcon src="/static/images/icons/pause2.svg" alt="Paused" />
                </HelpTooltip>
              </Box>
            </Tooltip>
          )}
        </UnitTypeWrapper>
      </TableCell>
      <TableCell>{l4Name}</TableCell>
      {props.isImportDate && (
        <TableCell>{props.user.createdDate && dateToMMDDYY(getDate(props.user.createdDate))}</TableCell>
      )}
      <TableCell>{props.user.registered ? "Yes" : "No"}</TableCell>
      <TableCell>{props.user.claimedDate && dateToMMDDYY(getDate(props.user.claimedDate))}</TableCell>
    </TableRow>
  );
};
